import axios from "../../utils/axios";

//订单设置详情
export function TicketSettingDetail(params) {
    return axios({
        url: `/web/operations/tickets/settings`,
        method: "get",
        params: params
    });
}

//订单设置更新
export function TicketSettingUpdate(data) {
    return axios({
        url: `/web/operations/tickets/settings/${data.id}`,
        method: "put",
        data: data
    });
}
